import { Box, Grid, Stack, Typography, useScrollTrigger } from "@mui/material";
import React from "react";
import filterIcon from "../../../../styles/svg/epic-icon.svg";
import { useResponsive } from "../../../../hooks/useResponsive";
import newSearchIcon from "../../../../styles/svg/newSearchIcon.svg";
import Status from "./Status";

const MobileFilterButton = ({
  setFilterDrawer,
  handleOpenSearchField = () => {},
}) => {
  const isMobile = useResponsive("down", "md");
  const trigger = useScrollTrigger();
  return (
    <>
      <Box sx={{ height: "55px", visibility: "hidden" }}></Box>
      <Grid
        container
        xs={12}
        className="remove-container-width fixed-ui"
        sx={{
          position: "fixed !important",
          top: trigger ? "0px" : isMobile ? "51px" : "",
        }}
        justifyContent={"center"}
        pb={"18px !important"}
        pt={trigger ? "24px !important" : "20px !important"}
        alignItems={"center"}>
        <Grid item xs={9} className="d-flex align-items-center">
          <Typography fontWeight={600} fontSize={20}>
            Task Assignments
          </Typography>
          <Status setIsVisible={() => ""} />
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" gap={1} justifyContent="end">
            <img
              src={newSearchIcon}
              className="mobile-board-search-icon"
              alt="search"
              onClick={handleOpenSearchField}
            />
            <img
              src={filterIcon}
              alt="filter"
              style={{ marginRight: "8px" }}
              onClick={() => setFilterDrawer(true)}
            />
          </Stack>{" "}
        </Grid>
      </Grid>
    </>
  );
};

export default MobileFilterButton;
